export const DASHBOARD_BASE = "/dashboard";

export const DASHBOARD_ROUTE_SEGMENTS = [
  "orders",
  "inventory",
  "messages",
  "yard-management",
  "shipments",
  "contracts",
  "invoices",
  "upload",
  "appointments",
  "manage-team",
  "notifications",
  "locations",
  "analytics",
  "transaction-audit",
  "resource-selection",
];

export const YARD_MANAGEMENT_ROUTE_SEGMENTS = [
  "appointment-check-in",
];

/** True for /dashboard and /dashboard/... but not /dashboardsomething */
export function isDashboardPath(pathname) {
  return /^\/dashboard(\/|$)/.test(pathname);
}

export function isKnownDashboardRoute(pathname) {
  if (!isDashboardPath(pathname)) {
    return false;
  }

  const remainder = pathname.replace(/^\/dashboard\/?/, "");
  if (!remainder) {
    return true;
  }

  const segments = remainder.split("/").filter(Boolean);
  const [first, second, ...rest] = segments;

  if (!DASHBOARD_ROUTE_SEGMENTS.includes(first)) {
    return false;
  }

  if (first === "yard-management") {
    if (rest.length > 0) {
      return false;
    }
    return (
      second === undefined ||
      YARD_MANAGEMENT_ROUTE_SEGMENTS.includes(second)
    );
  }

  return segments.length === 1;
}

export function isUnknownDashboardRoute(pathname) {
  return isDashboardPath(pathname) && !isKnownDashboardRoute(pathname);
}

const AUTH_PATHS = ["/login", "/signup"];

export function getPostLoginRedirect(fromLocation, fallback = "/dashboard/shipments") {
  const pathname = fromLocation?.pathname;

  if (!pathname || typeof pathname !== "string" || !pathname.startsWith("/")) {
    return fallback;
  }

  if (AUTH_PATHS.some((path) => pathname === path || pathname.startsWith(`${path}/`))) {
    return fallback;
  }

  if (isDashboardPath(pathname) && !isKnownDashboardRoute(pathname)) {
    return fallback;
  }

  return `${pathname}${fromLocation.search || ""}${fromLocation.hash || ""}`;
}
